import React from 'react';

interface TimelineProps {
  description: string;
  subText?: string;
  items: string[];
}

const Timeline: React.FC<TimelineProps> = ({ description, subText, items }) => {
  return (
    <div className="timeline-container">
      <h3 className="timeline-description">{description}</h3>
      {subText && <p className="timeline-text" style={{ marginBottom: '8px', marginLeft: '40px' }}>{subText}</p>}
      <ul className="timeline-list">
        {items.map((item, index) => (
          <li key={index} className="timeline-item">
            <p className="timeline-text">{item}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Timeline;
